import { isProduction } from './nodeEnv';

const devConsoleErrorMessages = {
  missingMessage: 'A console message is missing.',
  unsupportedConsoleLevel:
    'The provided console level is currently not supported. Please choose one of the following: '
};

// use mapping instead of direct assignment using condition in case of addition of new levels in the future (for example: info)
const consoleLevelFunctionsMapping = {
  warn: console.warn,
  error: console.error
};

const checkForInputErrors = (severityLevel, message) => {
  let errorMessage;
  const supportedConsoleLevels = Object.keys(consoleLevelFunctionsMapping).join(
    ', '
  );

  // a console message is required
  if (!message) {
    errorMessage = devConsoleErrorMessages.missingMessage;
  } else {
    const isUnsupportedConsoleLevel =
      consoleLevelFunctionsMapping[severityLevel] === undefined;
    if (isUnsupportedConsoleLevel) {
      errorMessage = `${devConsoleErrorMessages.unsupportedConsoleLevel} ${supportedConsoleLevels}`;
    }
  }

  return errorMessage;
};

/**
 *
 * @param {string} severityLevel - console's severity level, currently supports warn, error
 * @param {bool} promptWhen - condition by which the message will be displayed, will log messages (by default) if no condition was provided
 * @param  {string} message - message to display in console
 */
const devModeConsole = ({
  severityLevel = 'warn',
  promptWhen = true,
  message
}) => {
  if (isProduction) {
    return;
  }

  const inputErrorMessage = checkForInputErrors(severityLevel, message);
  if (inputErrorMessage) {
    console.error(`[fe-ui-core] devModeConsole: ${inputErrorMessage}`);
    return;
  }

  if (promptWhen) {
    const log = consoleLevelFunctionsMapping[severityLevel];
    log(message);
  }
};

export default devModeConsole;
